import initVueGoogleMaps from './vue-google-maps';
import initVueDialog from './vue-dialog';
import initVuePaginate from './vue-paginate'

export default (apiKey) => {
  initVuePaginate()
  initVueGoogleMaps(apiKey);
  initVueDialog();
}
